// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Belt_MapString = require("bs-platform/lib/js/belt_MapString.js");
var Pin$XodProject = require("xod-project/src/Pin.bs.js");
var Link$XodProject = require("xod-project/src/Link.bs.js");
var Node$XodProject = require("xod-project/src/Node.bs.js");
var BeltHoles_Result = require("belt-holes/src/BeltHoles_Result.bs.js");
var BeltHoles_String = require("belt-holes/src/BeltHoles_String.bs.js");
var Patch$XodProject = require("xod-project/src/Patch.bs.js");
var Caml_js_exceptions = require("bs-platform/lib/js/caml_js_exceptions.js");
var Project$XodProject = require("xod-project/src/Project.bs.js");
var TabData$XodTabtest = require("./TabData.bs.js");
var BeltHoles_Map_String = require("belt-holes/src/BeltHoles_Map_String.bs.js");
var PatchPath$XodProject = require("xod-project/src/PatchPath.bs.js");
var Strings$XodFuncTools = require("xod-func-tools/src/Strings.bs.js");
var Validator$XodTabtest = require("./Validator.bs.js");
var Transpiler$XodArduino = require("xod-arduino/src/Transpiler.bs.js");
var SpecialColumns$XodTabtest = require("./SpecialColumns.bs.js");
var TabtestLibPatchesJson = require("../lib/tabtestLibPatches.json");

function patchPath(tp, dir) {
  var tmp;
  switch (tp) {
    case /* Pulse */0 :
        tmp = "pulse";
        break;
    case /* Boolean */1 :
        tmp = "boolean";
        break;
    case /* Number */2 :
        tmp = "number";
        break;
    case /* Byte */3 :
        tmp = "byte";
        break;
    case /* String */4 :
        tmp = "string";
        break;
    
  }
  return "xod/tabtest/" + ((
            dir ? "capture-" : "inject-"
          ) + tmp);
}

function create(pin) {
  return {
          node: Node$XodProject.create(patchPath(Pin$XodProject.getPrimitiveTypeExn(pin), Pin$XodProject.getDirection(pin))),
          targetPin: pin
        };
}

function getPinKeyExn(probe, project) {
  var node = probe.node;
  var pt = Node$XodProject.getType(node);
  var match = Project$XodProject.getPatchByNode(project, node);
  var patch = match !== undefined ? Caml_option.valFromOption(match) : Js_exn.raiseError("Probe has unexpected type " + pt);
  var pin = Patch$XodProject.findPinByLabel(patch, "VAL", true, undefined);
  if (pin !== undefined) {
    return Pin$XodProject.getKey(Caml_option.valFromOption(pin));
  } else {
    return Js_exn.raiseError("Expected all probes to have the only pin labeled 'VAL'. " + (pt + " violates the rule"));
  }
}

function keepToPinDirection(probes, dir) {
  return Belt_List.keep(probes, (function (probe) {
                return Pin$XodProject.getDirection(probe.targetPin) === dir;
              }));
}

function newError(message) {
  try {
    return Js_exn.raiseError(message);
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn[0] === Js_exn.$$Error) {
      return exn[1];
    } else {
      throw exn;
    }
  }
}

function create$1(project, patchUnderTest) {
  var nut = Node$XodProject.create(Patch$XodProject.getPath(patchUnderTest));
  var nutId = Node$XodProject.getId(nut);
  var draftBench_patch = Patch$XodProject.assocNode(Patch$XodProject.create(/* () */0), nut);
  var draftBench = {
    patch: draftBench_patch,
    probes: /* [] */0,
    probeMap: Belt_MapString.empty
  };
  return Belt_List.reduce(Belt_List.map(Pin$XodProject.normalizeLabels(Patch$XodProject.listPins(patchUnderTest)), create), draftBench, (function (bench, probe) {
                var probeNode = probe.node;
                var probeId = Node$XodProject.getId(probeNode);
                var probePK = getPinKeyExn(probe, project);
                var targPin = probe.targetPin;
                var targPK = Pin$XodProject.getKey(targPin);
                var match = Pin$XodProject.getDirection(targPin);
                var link = match ? Link$XodProject.create(probePK, probeId, targPK, nutId) : Link$XodProject.create(targPK, nutId, probePK, probeId);
                return {
                        patch: Patch$XodProject.assocLink(Patch$XodProject.assocNode(bench.patch, probeNode), link),
                        probes: /* :: */[
                          probe,
                          bench.probes
                        ],
                        probeMap: Belt_MapString.set(bench.probeMap, Pin$XodProject.getLabel(targPin), probeId)
                      };
              }));
}

function enquote(x) {
  return "\"" + (String(x) + "\"");
}

function block(children) {
  return BeltHoles_String.joinLines(/* :: */[
              "{",
              /* :: */[
                BeltHoles_String.indent(BeltHoles_String.joinLines(children), 4),
                /* :: */[
                  "}",
                  /* [] */0
                ]
              ]
            ]);
}

function catch2TestCase(name, children) {
  return "TEST_CASE(" + (enquote(name) + (") " + block(children)));
}

function requireEqual(actual, expected) {
  return "REQUIRE(" + (String(actual) + (" == " + (String(expected) + ");")));
}

function requireIsNan(value) {
  return "REQUIRE(isnan(" + (String(value) + "));");
}

function valueToLiteral(value) {
  if (typeof value === "number") {
    if (value === /* NaN */1) {
      return "NAN";
    } else {
      return "" + (String(value) + "");
    }
  } else {
    switch (value.tag | 0) {
      case /* Number */0 :
          var x = value[0];
          if (x === Pervasives.infinity) {
            return "(xod::Number) INFINITY";
          } else if (x === Pervasives.neg_infinity) {
            return "(xod::Number) -INFINITY";
          } else {
            return "(xod::Number) " + (String(x) + "");
          }
      case /* ApproxNumber */1 :
          var margin = Math.pow(10.0, value[1]) / 2.0;
          return "Approx((xod::Number) " + (String(value[0]) + (").margin(" + (String(margin) + ")")));
      case /* Boolean */2 :
          if (value[0]) {
            return "true";
          } else {
            return "false";
          }
      case /* String */3 :
          var str = enquote(value[0]);
          return "xod::XStringCString(" + (String(str) + ")");
      case /* Pulse */5 :
          if (value[0]) {
            return "true /* pulse */";
          } else {
            return "false /* no-pulse */";
          }
      default:
        return "" + (String(value) + "");
    }
  }
}

function shouldValueBePersistedBetweenCases(value) {
  if (typeof value === "number" || value.tag !== /* String */3) {
    return false;
  } else {
    return true;
  }
}

function getPersistedValueName(caseNumber, probeName) {
  return "injected_case" + (String(caseNumber) + ("_" + (String(probeName) + "")));
}

function generate(name, tabData, idMap, probes) {
  var nodeAliases = Belt_List.map(Belt_MapString.toList(idMap), (function (param) {
          var id = param[1];
          var probeName = Strings$XodFuncTools.cppEscape(param[0]);
          return BeltHoles_String.joinLines(/* :: */[
                      "auto& probe_" + (String(probeName) + (" = xod::node_" + (String(id) + ";"))),
                      /* :: */[
                        "#define MARK_DIRTY_probe_" + (String(probeName) + (" xod::g_transaction.node_" + (String(id) + "_isNodeDirty = true;"))),
                        /* [] */0
                      ]
                    ]);
        }));
  var sections = TabData$XodTabtest.mapWithIndex(tabData, (function (idx, record) {
          var record$1 = record;
          var probes$1 = probes;
          var sectionIndex = idx;
          var humanReadableCaseNumber = sectionIndex + 1 | 0;
          var persistedInjectedValues = Belt_List.keepMap(keepToPinDirection(probes$1, /* Input */0), (function (probe) {
                  var name = Pin$XodProject.getLabel(probe.targetPin);
                  var probeName = Strings$XodFuncTools.cppEscape(name);
                  var match = TabData$XodTabtest.Record.get(record$1, name);
                  if (match !== undefined) {
                    var value = match;
                    if (typeof value === "number" && value >= 2) {
                      return ;
                    }
                    if (shouldValueBePersistedBetweenCases(value)) {
                      var name$1 = getPersistedValueName(humanReadableCaseNumber, probeName);
                      var literal = valueToLiteral(value);
                      return "auto const " + (String(name$1) + (" = " + (String(literal) + ";")));
                    } else {
                      return ;
                    }
                  }
                  
                }));
          var injectionStatements = Belt_List.map(keepToPinDirection(probes$1, /* Input */0), (function (probe) {
                  var name = Pin$XodProject.getLabel(probe.targetPin);
                  var probeName = Strings$XodFuncTools.cppEscape(name);
                  var match = TabData$XodTabtest.Record.get(record$1, name);
                  if (match !== undefined) {
                    var value = match;
                    if (typeof value === "number") {
                      if (value === /* RaisedError */2) {
                        return "INJECT_ERROR(probe_" + (String(probeName) + ");");
                      }
                      
                    } else if (value.tag === /* Pulse */5) {
                      if (value[0]) {
                        return "INJECT_PULSE(probe_" + (String(probeName) + ");");
                      } else {
                        return "// No pulse for " + (String(name) + "");
                      }
                    }
                    var literal = shouldValueBePersistedBetweenCases(value) ? getPersistedValueName(humanReadableCaseNumber, probeName) : valueToLiteral(value);
                    return "INJECT(probe_" + (String(probeName) + (", " + (String(literal) + ");")));
                  } else {
                    return "// No changes for " + (String(name) + "");
                  }
                }));
          var match = TabData$XodTabtest.Record.get(record$1, SpecialColumns$XodTabtest.time);
          var setTimeStatement;
          if (match !== undefined) {
            var match$1 = match;
            if (typeof match$1 === "number" || match$1.tag) {
              setTimeStatement = "mockTime(millis() + 1);";
            } else {
              var time = match$1[0] | 0;
              setTimeStatement = "mockTime(" + (String(time) + ");");
            }
          } else {
            setTimeStatement = "mockTime(millis() + 1);";
          }
          var assertionsStatements = Belt_List.map(keepToPinDirection(probes$1, /* Output */1), (function (probe) {
                  var name = Pin$XodProject.getLabel(probe.targetPin);
                  var match = Belt_MapString.get(record$1, name);
                  if (match !== undefined) {
                    var value = match;
                    if (typeof value === "number") {
                      switch (value) {
                        case /* Empty */0 :
                            break;
                        case /* NaN */1 :
                            return BeltHoles_String.joinLines(/* :: */[
                                        requireIsNan("probe_" + (String(name) + ".state.lastValue")),
                                        /* :: */[
                                          requireEqual("probe_" + (String(name) + ".state.hadError"), "false"),
                                          /* [] */0
                                        ]
                                      ]);
                        case /* RaisedError */2 :
                            return requireEqual("probe_" + (String(name) + ".state.hadError"), "true");
                        
                      }
                    }
                    return BeltHoles_String.joinLines(/* :: */[
                                requireEqual("probe_" + (String(name) + ".state.lastValue"), valueToLiteral(value)),
                                /* :: */[
                                  requireEqual("probe_" + (String(name) + ".state.hadError"), "false"),
                                  /* [] */0
                                ]
                              ]);
                  } else {
                    return "// no expectation for " + (String(name) + "");
                  }
                }));
          var persistedValues = persistedInjectedValues;
          var name = "Case " + (String(humanReadableCaseNumber) + "");
          var children = /* :: */[
            BeltHoles_String.joinLines(injectionStatements),
            /* :: */[
              setTimeStatement,
              /* :: */[
                sectionIndex === 0 ? "setup();" : "loop();",
                /* :: */[
                  BeltHoles_String.joinLines(assertionsStatements),
                  /* [] */0
                ]
              ]
            ]
          ];
          var joinedPersistedValues = Belt_List.length(persistedValues) > 0 ? BeltHoles_String.joinLines(persistedValues) + "\n" : "";
          return joinedPersistedValues + ("SECTION(" + (enquote(name) + (") " + block(children))));
        }));
  return BeltHoles_String.joinLines(/* :: */[
              "#include \"catch.hpp\"",
              /* :: */[
                "#include <XStringFormat.inl>",
                /* :: */[
                  "",
                  /* :: */[
                    BeltHoles_String.joinLines(nodeAliases),
                    /* :: */[
                      "",
                      /* :: */[
                        "#define INJECT(probe, value) \\",
                        /* :: */[
                          "        (probe)._output_VAL = (value); \\",
                          /* :: */[
                            "        (probe).state.shouldRaise = false; \\",
                            /* :: */[
                              "        MARK_DIRTY_##probe;",
                              /* :: */[
                                "",
                                /* :: */[
                                  "#define INJECT_PULSE(probe) \\",
                                  /* :: */[
                                    "        (probe).state.shouldPulse = true; \\",
                                    /* :: */[
                                      "        (probe).state.shouldRaise = false; \\",
                                      /* :: */[
                                        "        MARK_DIRTY_##probe;",
                                        /* :: */[
                                          "",
                                          /* :: */[
                                            "#define INJECT_ERROR(probe) \\",
                                            /* :: */[
                                              "        (probe).state.shouldRaise = true;\\",
                                              /* :: */[
                                                "        MARK_DIRTY_##probe;",
                                                /* :: */[
                                                  "",
                                                  /* :: */[
                                                    catch2TestCase(name, /* :: */[
                                                          BeltHoles_String.joinLines(sections),
                                                          /* [] */0
                                                        ]),
                                                    /* [] */0
                                                  ]
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var tabtestLibPatches = TabtestLibPatchesJson;

function generatePatchSuite(project, patchPathToTest) {
  var projectWithTabtestLib = Project$XodProject.upsertPatches(project, Belt_List.fromArray(tabtestLibPatches));
  var patchUnderTestOpt = Project$XodProject.getPatchByPath(projectWithTabtestLib, patchPathToTest);
  var tsvOpt = Belt_Option.flatMap(patchUnderTestOpt, Patch$XodProject.getTabtestContent);
  if (patchUnderTestOpt !== undefined) {
    if (tsvOpt !== undefined) {
      var tsv = tsvOpt;
      var bench = create$1(projectWithTabtestLib, Caml_option.valFromOption(patchUnderTestOpt));
      var probes = bench.probes;
      var tabData = TabData$XodTabtest.parse(tsv);
      var realPinLabels = Belt_List.fromArray(Belt_MapString.keysToArray(bench.probeMap));
      var testingPinLabels = TabData$XodTabtest.tabSplit(Belt_List.getExn(TabData$XodTabtest.listDataLines(tsv), 0));
      var match = Validator$XodTabtest.validatePinLabels(realPinLabels, testingPinLabels);
      if (match !== undefined) {
        return /* Error */Block.__(1, [Caml_option.valFromOption(match)]);
      } else {
        var benchPatchPath = ("tabtest-" + patchPathToTest).replace("-@", "/local");
        var safeBasename = PatchPath$XodProject.getBaseName(patchPathToTest).replace("(", "__").replace(",", "__").replace(")", "");
        var sketchFilename = safeBasename + ".sketch.cpp";
        var testFilename = safeBasename + ".catch.inl";
        var sketchFooter = "\n\n#include \"" + (String(testFilename) + "\"\n");
        var __x = Project$XodProject.assocPatch(projectWithTabtestLib, benchPatchPath, bench.patch);
        return BeltHoles_Result.map(Transpiler$XodArduino.transpile(__x, benchPatchPath, /* None */0, Belt_MapString.empty), (function (program) {
                      var idMap = BeltHoles_Map_String.innerJoin(bench.probeMap, program.nodeIdMap);
                      var testCase = generate(patchPathToTest, tabData, idMap, probes);
                      return Belt_MapString.set(Belt_MapString.set(Belt_MapString.empty, sketchFilename, program.code + sketchFooter), testFilename, testCase);
                    }));
      }
    } else {
      return /* Error */Block.__(1, [newError("Patch " + (String(patchPathToTest) + " has no tabular test data attached"))]);
    }
  } else {
    return /* Error */Block.__(1, [newError("Patch " + (String(patchPathToTest) + " does not exist in the project"))]);
  }
}

function generateProjectSuite(project) {
  return Belt_List.reduce(Belt_List.map(Belt_List.keep(Project$XodProject.listLocalPatches(project), Patch$XodProject.hasTabtest), Patch$XodProject.getPath), /* Ok */Block.__(0, [Belt_MapString.empty]), (function (accFiles, patchPath) {
                return BeltHoles_Result.lift2(BeltHoles_Map_String.mergeOverride, accFiles, generatePatchSuite(project, patchPath));
              }));
}

exports.generatePatchSuite = generatePatchSuite;
exports.generateProjectSuite = generateProjectSuite;
/* tabtestLibPatches Not a pure module */



//////////////////
// WEBPACK FOOTER
// ../xod-tabtest/src/Tabtest.bs.js
// module id = 1466
// module chunks = 0